import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetUser} from '@/features/users/http/users.http.ts'
import {UserExtended, UserSmall} from '@/features/users/types.ts'
import {raise} from '@utilities/helpers.ts'
import {ResponseType} from '@/types'

type UserResponse<T extends ResponseType> = T extends 'extended' ? UserExtended : UserSmall

export const useGetUser = <T extends ResponseType>({
    userId,
    responseType,
    options
}: {
    userId?: string
    responseType?: T
    options?: Omit<UseQueryOptions<UserResponse<T>>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.USERS, userId, responseType],
        queryFn: () =>
            httpGetUser({
                urlParams: {userId: userId ?? raise('userId is nullish')},
                params: {responseType: responseType ?? 'extended'}
            }),
        ...options
    })
